import { formatCurrency, formatDate, formatDateWithoutTime } from '../fomatter.utils'
import { BODY_FONT, splitLines, wrapText } from '../text.utils'
import type { TicketElement } from '../TicketElement'
import type { InfoItemOptions } from '../types'

export class InfoItem implements TicketElement {
  label: string
  value: string | number | Date | undefined | null
  valueType: 'text' | 'string' | 'date' | 'currency' | 'dateWithoutTime'
  important: boolean
  labelFont: string
  fontSize: number
  lineHeight: number
  keepTogether: boolean
  formattedValue: string

  constructor(
    label: string,
    value: string | number | Date | undefined | null,
    { valueType, important, keepTogether, fontSize = 16 }: InfoItemOptions = {}
  ) {
    this.label = label + ':'
    this.value = value
    this.valueType = valueType || 'string'
    this.important = important || false
    this.labelFont = this.important
      ? `700 ${fontSize}px ${BODY_FONT}`
      : `${fontSize}px ${BODY_FONT}`
    this.fontSize = fontSize
    this.lineHeight = fontSize * 1.5
    this.keepTogether = !!keepTogether
    if (this.valueType === 'date') {
      this.formattedValue = formatDate(this.value as Date)
    } else if (this.valueType === 'currency') {
      this.formattedValue = formatCurrency(+this.value!)
    } else if (this.valueType === 'dateWithoutTime') {
      this.formattedValue = formatDateWithoutTime(this.value as Date)
    } else {
      this.formattedValue = String(this.value)
    }
  }

  height(ctx: CanvasRenderingContext2D, width: number): number {
    if (this.value === undefined || this.value === null || this.value === '') return 0
    ctx.font = this.labelFont
    ctx.textAlign = 'right'
    let height: number
    if (!this.keepTogether) {
      const valueWidth = width - (ctx.measureText(this.label).width + 10)
      const linesLabel = splitLines(ctx, this.label, width)
      const linesValue = splitLines(ctx, this.formattedValue, width, valueWidth)
      height = this.lineHeight * (linesLabel.length + linesValue.length - 1)
    } else {
      const labelWidth = ctx.measureText(this.label).width + 5
      const valueWidth = width - (labelWidth + 5)
      const linesValue = splitLines(ctx, this.formattedValue, width, valueWidth)
      height = this.lineHeight * linesValue.length
    }
    return height
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    if (this.value === undefined || this.value === null || this.value === '') return
    top += this.lineHeight
    ctx.font = this.labelFont
    ctx.fillStyle = 'black'
    ctx.textBaseline = 'bottom'
    ctx.textAlign = 'left'
    const valueWidth = width - (ctx.measureText(this.label).width + 10)
    if (!this.keepTogether) {
      wrapText(ctx, this.label, 0, top, width, {
        lineHeight: this.fontSize * 1.5
      })
      ctx.textAlign = 'right'
      const lines = splitLines(ctx, this.label, width)
      top += this.lineHeight * (lines.length - 1)
      wrapText(ctx, this.formattedValue, width, top, width, {
        firstMaxWidth: valueWidth
      })
    } else {
      ctx.fillText(this.label, 0, top)
      wrapText(ctx, this.formattedValue, ctx.measureText(this.label).width + 5, top, width, {
        lineHeight: this.lineHeight,
        decreaseIndent: true,
        firstMaxWidth: valueWidth
      })
    }
  }
}
